import { render } from "./ScPagerSimulator.vue?vue&type=template&id=505f3e81"
import script from "./ScPagerSimulator.vue?vue&type=script&lang=js"
export * from "./ScPagerSimulator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable2/ScPagerSimulator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "505f3e81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('505f3e81', __exports__)) {
    console.log('reload')
    api.reload('505f3e81', __exports__)
  }
  
  module.hot.accept("./ScPagerSimulator.vue?vue&type=template&id=505f3e81", () => {
    console.log('re-render')
    api.rerender('505f3e81', render)
  })

}


export default __exports__